export const TopziteOreIcon = ({ size = 24, className = '' }: { size?: number; className?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="tz-lt" x1="0.2" y1="0" x2="0.8" y2="1">
        <stop offset="0%" stopColor="#b2f5ea" />
        <stop offset="40%" stopColor="#5eead4" />
        <stop offset="100%" stopColor="#2dd4bf" />
      </linearGradient>
      <linearGradient id="tz-lr" x1="0" y1="0" x2="1" y2="0.8">
        <stop offset="0%" stopColor="#5eead4" />
        <stop offset="60%" stopColor="#14b8a6" />
        <stop offset="100%" stopColor="#0d9488" />
      </linearGradient>
      <linearGradient id="tz-lm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#2dd4bf" />
        <stop offset="50%" stopColor="#14b8a6" />
        <stop offset="100%" stopColor="#0d9488" />
      </linearGradient>
      <linearGradient id="tz-ll" x1="1" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#14b8a6" />
        <stop offset="50%" stopColor="#0d9488" />
        <stop offset="100%" stopColor="#0f766e" />
      </linearGradient>
      <linearGradient id="tz-lb" x1="0.5" y1="0" x2="0.5" y2="1">
        <stop offset="0%" stopColor="#0d9488" />
        <stop offset="100%" stopColor="#0f766e" />
      </linearGradient>
      <linearGradient id="tz-lbr" x1="0" y1="0" x2="0.8" y2="1">
        <stop offset="0%" stopColor="#14b8a6" />
        <stop offset="100%" stopColor="#0d9488" />
      </linearGradient>
      <radialGradient id="tz-ls" cx="0.4" cy="0.3" r="0.4">
        <stop offset="0%" stopColor="#fff" stopOpacity={0.9} />
        <stop offset="25%" stopColor="#ccfbf1" stopOpacity={0.4} />
        <stop offset="100%" stopColor="#14b8a6" stopOpacity={0} />
      </radialGradient>
    </defs>
    {/* Base fill */}
    <path d="M260 42 L210 70 L100 230 L130 320 L200 420 L310 410 L380 370 L410 210 L370 110 L310 70Z" fill="#0d9488" />
    {/* Facets */}
    <path d="M130 320 L100 230 L175 160 L220 260Z" fill="url(#tz-lb)" />
    <path d="M100 230 L175 160 L210 70 L256 130Z" fill="url(#tz-ll)" />
    <path d="M210 70 L256 130 L310 70 L260 42Z" fill="url(#tz-lt)" />
    <path d="M256 130 L310 70 L370 110 L340 170Z" fill="url(#tz-lr)" />
    <path d="M175 160 L256 130 L340 170 L360 290 L280 360 L220 260Z" fill="url(#tz-lm)" />
    <path d="M340 170 L370 110 L410 210 L360 290Z" fill="url(#tz-lr)" />
    <path d="M280 360 L360 290 L380 370 L310 410Z" fill="url(#tz-lbr)" />
    <path d="M130 320 L220 260 L280 360 L310 410 L200 420Z" fill="url(#tz-lb)" />
    {/* Inner edges */}
    <g stroke="#0f172a" strokeWidth="1.5" strokeLinecap="round" fill="none">
      <line x1="100" y1="230" x2="175" y2="160" />
      <line x1="175" y1="160" x2="220" y2="260" />
      <line x1="175" y1="160" x2="256" y2="130" />
      <line x1="210" y1="70" x2="256" y2="130" />
      <line x1="256" y1="130" x2="310" y2="70" />
      <line x1="256" y1="130" x2="340" y2="170" />
      <line x1="340" y1="170" x2="370" y2="110" />
      <line x1="340" y1="170" x2="360" y2="290" />
      <line x1="360" y1="290" x2="280" y2="360" />
      <line x1="220" y1="260" x2="280" y2="360" />
      <line x1="220" y1="260" x2="130" y2="320" />
      <line x1="280" y1="360" x2="310" y2="410" />
      <line x1="360" y1="290" x2="380" y2="370" />
      <line x1="360" y1="290" x2="410" y2="210" />
    </g>
    {/* Outer silhouette */}
    <path d="M260 42 L210 70 L100 230 L130 320 L200 420 L310 410 L380 370 L410 210 L370 110 L310 70Z" fill="none" stroke="#0f172a" strokeWidth="4.5" strokeLinejoin="round" />
    {/* Shine */}
    <ellipse cx="270" cy="130" rx="100" ry="80" fill="url(#tz-ls)" />
  </svg>
);
